// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1YbMX","validationTips":"StatementDescriptor_validationTips__2CjKj"};